module.exports = __webpack_public_path__ + "static/media/Add_Prize.a1def7ef.png";